/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  work_id: z.number(),
  material_id: z.number(),
  order_kind: z.string(),
  ordered_at: z.number(),
  qty: z.number(),
  unit: z.string(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  order_kind: base.shape.order_kind.optional(),
  qty: base.shape.qty.optional(),
  unit: base.shape.unit.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const StockOrderBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type StockOrderBase = z.infer<typeof base>;
export type StockOrderBasePutPayload = z.infer<typeof put>;
export type StockOrderBasePatchPayload = z.infer<typeof patch>;
export type StockOrderBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type StockOrderBaseCreateAttributes = z.infer<typeof create>;
export type StockOrderBaseUpdateAttributes = z.infer<typeof update>;
export type StockOrderBaseCacheAttributes = z.infer<typeof cache>;
export type StockOrderBaseCachesAttributes = z.infer<typeof caches>;